import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import InfoIcon from 'app/assets/icons/info-2.svg?react';

export default function TooltipElement({ title, placement = 'top' }) {
  return (
    <StyledTooltip title={title} arrow placement={placement}>
      <div>
        <InfoIcon className="w-14 h-14" />
      </div>
    </StyledTooltip>
  );
}

export const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#191B24',
    padding: '10px',
    borderRadius: '4px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#191B24',
  },
});
